/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ComparisonStatus } from './ComparisonStatus';
import {
    ComparisonStatusFromJSON,
    ComparisonStatusFromJSONTyped,
    ComparisonStatusToJSON,
    ComparisonStatusToJSONTyped,
} from './ComparisonStatus';

/**
 * Base comparison record returned by the API
 * @export
 * @interface Comparison
 */
export interface Comparison {
    /**
     * Unique comparison ID
     * @type {number}
     * @memberof Comparison
     */
    readonly id: number;
    /**
     * ID of the parent claim
     * @type {number}
     * @memberof Comparison
     */
    claimId: number;
    /**
     * Display name (auto-generated as "Comparison
     * @type {string}
     * @memberof Comparison
     */
    name: string;
    /**
     * ID of the insurer estimate being compared
     * @type {number}
     * @memberof Comparison
     */
    insurerEstimateId: number;
    /**
     * ID of the contractor estimate being compared
     * @type {number}
     * @memberof Comparison
     */
    contractorEstimateId: number;
    /**
     * 
     * @type {ComparisonStatus}
     * @memberof Comparison
     */
    status: ComparisonStatus;
    /**
     * Human-readable status message
     * @type {string}
     * @memberof Comparison
     */
    statusMessage?: string | null;
    /**
     * Error message if processing failed
     * @type {string}
     * @memberof Comparison
     */
    errorMessage?: string | null;
    /**
     * AI processing time in milliseconds (static after completion)
     * @type {number}
     * @memberof Comparison
     */
    processingTimeMs?: number | null;
    /**
     * When the comparison was created
     * @type {Date}
     * @memberof Comparison
     */
    readonly createdAt: Date;
    /**
     * When the comparison was last updated
     * @type {Date}
     * @memberof Comparison
     */
    readonly updatedAt: Date;
    /**
     * ID of the user who created the comparison
     * @type {number}
     * @memberof Comparison
     */
    createdBy: number;
}



/**
 * Check if a given object implements the Comparison interface.
 */
export function instanceOfComparison(value: object): value is Comparison {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('insurerEstimateId' in value) || value['insurerEstimateId'] === undefined) return false;
    if (!('contractorEstimateId' in value) || value['contractorEstimateId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    return true;
}

export function ComparisonFromJSON(json: any): Comparison {
    return ComparisonFromJSONTyped(json, false);
}

export function ComparisonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Comparison {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'name': json['name'],
        'insurerEstimateId': json['insurerEstimateId'],
        'contractorEstimateId': json['contractorEstimateId'],
        'status': ComparisonStatusFromJSON(json['status']),
        'statusMessage': json['statusMessage'] == null ? undefined : json['statusMessage'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'processingTimeMs': json['processingTimeMs'] == null ? undefined : json['processingTimeMs'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'],
    };
}

export function ComparisonToJSON(json: any): Comparison {
    return ComparisonToJSONTyped(json, false);
}

export function ComparisonToJSONTyped(value?: Omit<Comparison, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'name': value['name'],
        'insurerEstimateId': value['insurerEstimateId'],
        'contractorEstimateId': value['contractorEstimateId'],
        'status': ComparisonStatusToJSON(value['status']),
        'statusMessage': value['statusMessage'],
        'errorMessage': value['errorMessage'],
        'processingTimeMs': value['processingTimeMs'],
        'createdBy': value['createdBy'],
    };
}

